import styled from "styled-components/macro";

export const PageWideScrollBox = styled.div<{ topMargin?: number }>`
  height: calc(100vh - 75px - ${(p) => p.topMargin}px);
  width: calc(100vw - 57px);
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0;
  margin: 0;

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-track {
    background: ${(p) => p.theme.palette.backgroundSecondary};
  }
  ::-webkit-scrollbar-thumb {
    background: ${(p) => p.theme.palette.accentPrimary};
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${(p) => p.theme.palette.accentSecondary};
  }
  ::-webkit-scrollbar-corner {
    background: ${(p) => p.theme.palette.backgroundSecondary};
  }
`;
PageWideScrollBox.defaultProps = {
  topMargin: 0,
};
